module.exports = __webpack_public_path__ + "50d6ba981030739983b0cbbb37b3c379.pdf";